<div class="flyout has-close-btn" [ngClass]="{ 'open': isOpen, 'closed': !isOpen }" #flyout (click)="$event.stopPropagation()">
  <div class="flyout-container" [ngStyle]="{ width: width }">
    <div class="flyout-close-btn" (click)="close()" [matTooltip]="'Close' | translate">
      <i class="fa fa-times"></i>
    </div>

    <div class="flyout-component-template">
      <ng-template #container></ng-template>
    </div>
  </div>
</div>